import { IconProp } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleLeft,
  faAngleRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAppContext } from "../../../../../context/app.context";
import { useState, FC } from "react";
import Calendar from "react-calendar";
import classNames from "classnames";
import DateTimePickerClockComponent from "./date-time-picker-clock.component";
import datePickerHelper from "../date-picker.helper";
import ComponentClassnames from "../../../../types/component-classnames";
import { Detail } from "react-calendar/dist/cjs/shared/types";

type DateTimePickerProps = {
  classNames?: ComponentClassnames;
  value: Date | null;
  onChange: (date: Date) => void;
  minDate?: Date;
  maxDate?: Date;
};

const DateTimePickerComponent: FC<DateTimePickerProps> = (props) => {
  const { selectedAppLanguage } = useAppContext();
  const dateLocale = datePickerHelper.getDatePickerLocale(selectedAppLanguage);

  const [viewMode, setViewMode] = useState<Detail>("month");

  const DatePickerIcon = ({ icon }: { icon: IconProp }) => (
    <FontAwesomeIcon size="sm" icon={icon} />
  );

  const onDateChange = (date: Date | null | (Date | null)[]) => {
    if (date instanceof Date) {
      props.onChange(date);
    }
  };

  return (
    <div
      className={classNames(
        "date_time_picker_date_selector",
        "date_time_picker",
        props.classNames?.root,
      )}
    >
      <Calendar
        locale={dateLocale}
        minDate={props.minDate}
        maxDate={props.maxDate}
        view={viewMode}
        onViewChange={(value) => setViewMode(value.view)}
        prev2Label={<DatePickerIcon icon={faAngleDoubleLeft} />}
        prevLabel={<DatePickerIcon icon={faAngleLeft} />}
        nextLabel={<DatePickerIcon icon={faAngleRight} />}
        next2Label={<DatePickerIcon icon={faAngleDoubleRight} />}
        className="date_time_picker_calendar"
        value={props.value}
        onChange={onDateChange}
      />
      <DateTimePickerClockComponent
        selectedDate={props.value}
        onChange={props.onChange}
      />
    </div>
  );
};

export default DateTimePickerComponent;
